import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import FeaturedList from './FeaturedList';

const Tools = ({moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, cobrandId, model}) => {
  const [{ data, loading }] = useAxios({ url: `internal/cobrand/tools/${cobrandId ? cobrandId : ''}`, method: "get" });
    return (
        <FeaturedList 
        moveItem={(index, direction) => moveItem("tools", index, direction)}
        addItem={(option) => addItem("tools", option)}
        removeItem={(id) => removeItem("tools", id)}
        saveIndividual={saveIndividual}
        showUpdateBtn={showUpdateBtn}
        typeId={2}
        type="Tool" model={model} availableItems={data} />
    );
};

export default Tools;